import { paymentsTableAdapter, State, PaymentsTableInstance } from '@feature/payments-to-you/reducers/payments-to-you-table.reducers'
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { QueryBuilderConfigProvider } from '@common/filter/query-builder-config-provider';
import { IRow, ITableColumn } from '@common/models/table';
import * as filterSelectors from '@common/filter/selectors/filter.selectors';
import * as filterUtils from '@common/filter/filter-utils';
import * as filterReducers from '@common/filter/reducers/filter.reducers';
import { RuleSet, QueryBuilderConfig } from 'ngx-angular-query-builder';
import { PaymentTableFilterFieldProvider } from '@feature/payments-to-you/filters/payment-table-filter-field-provider';
import * as widgetConfigSelectors from "../../widget-configs/selectors/widget-configs";
import { WidgetConfiguration } from '@feature/widget-configs/models/widget-configuration';
import * as lodash from 'lodash';
import { StandardFilterStrategy } from '@common/filter/standard-filter-strategy';

export const selectPaymentTableState = createFeatureSelector<State>('paymentTable');

export type PaymentsFilterFieldProviderFactoryCallback = (rows: Array<IRow>, columns: Array<ITableColumn>) => PaymentTableFilterFieldProvider

export function makePaymentFilterFieldProviderCallback(): PaymentsFilterFieldProviderFactoryCallback {

    return (rows: Array<IRow>, columns: Array<ITableColumn>) => {
        return new PaymentTableFilterFieldProvider(rows, columns);
    }

}

export const {
    selectIds,
    selectEntities,
    selectTotal,
} = paymentsTableAdapter.getSelectors(selectPaymentTableState);


export const selectEntityByWidgetId = (widgetId: string) => createSelector(selectEntities, (entities) => entities[widgetId.toString()]);


export function getFilteredPaymentsWithDataKey(widgetId: string, widgetConfigId: number, filterFieldCallback: PaymentsFilterFieldProviderFactoryCallback) {
    return createSelector(
        [selectEntityByWidgetId(widgetId), getUserFilter(widgetId), widgetConfigSelectors.selectLoading(), widgetConfigSelectors.selectEntityByWidgetConfigId(widgetConfigId)],
        (paymentsTableInstance: PaymentsTableInstance, filter: RuleSet, widgetConfigLoading: boolean, widgetConfig: WidgetConfiguration) => {

            const applyFilter = paymentsTableInstance &&
                paymentsTableInstance.paymentsTable &&
                paymentsTableInstance.paymentsTable.Rows.length > 0 &&
                filter;



            if (applyFilter && !widgetConfigLoading) {

                const table = lodash.cloneDeep(paymentsTableInstance.paymentsTable);
                const paymentTableFilterFieldProvider = filterFieldCallback(table.Rows, table.Columns);
                const filterStrategy = new StandardFilterStrategy<IRow>(paymentTableFilterFieldProvider);
                table.Rows = filterStrategy.applyFilter(table.Rows, widgetConfig.filter);

                table.Rows = filterStrategy.applyFilter(table.Rows, filter);


                let count = 1;
                for (const tenancy of table.Rows) {
                    tenancy.DataKey = String(count++);
                }

                return table;
            }
            return undefined;
        }
    );
}

export function getUserFilter(widgetId: string) {
    return createSelector([filterSelectors.selectByWidgetId(widgetId), selectEntityByWidgetId(widgetId.toString())],
        (filter: filterReducers.WidgetFilterInstance, paymentsTableInstance: PaymentsTableInstance) => {
            if (filter && paymentsTableInstance && filter.filter) {
                return filter.filter;
            }
            return filterUtils.getDefaultFilter();
        });
}

export function getNoOfNewPayments(widgetId: string, previousLoginTime: Date) {
    return createSelector(
        [selectEntityByWidgetId(widgetId)],
        (paymentsTableInstance: PaymentsTableInstance) => {

            if (paymentsTableInstance.paymentsTable == undefined ||
                paymentsTableInstance.paymentsTable.Rows == undefined ||
                paymentsTableInstance.paymentsTable.Rows.length == 0) {
                return undefined;
            }

            let dateValueStrings: Array<string> = [];
            dateValueStrings = paymentsTableInstance.paymentsTable.Rows.map(item => item['SystemPaidDate']);
            const dates = dateValueStrings.filter(x => { return x != undefined }).map(x => new Date(x));
            let count = 0;
            for (let i = 0; i < dates.length; ++i) {
                if (dates[i] > previousLoginTime)
                    count++;
            }

            return count;
        }
    );
}

export function getQueryBuilderConfig(widgetId: string, filterFieldCallback: PaymentsFilterFieldProviderFactoryCallback) {
    return createSelector(
        [selectEntityByWidgetId(widgetId)],
        (paymentsTableInstance: PaymentsTableInstance) => {
            if (paymentsTableInstance &&
                paymentsTableInstance.paymentsTable) {

                const paymentFilterFieldProvider = filterFieldCallback(paymentsTableInstance.paymentsTable.Rows, paymentsTableInstance.paymentsTable.Columns);
                const paymentFilterFieldProviderQueryConfigBuilder = new QueryBuilderConfigProvider(paymentFilterFieldProvider);
                return paymentFilterFieldProviderQueryConfigBuilder.getQueryBuilderConfig() as QueryBuilderConfig;
            } else {
                return { fields: {} } as QueryBuilderConfig;
            }
        }
    );
}
